export default __webpack_public_path__ + "static/media/nfttech.f8cff406.mp4";